<div class="loading-spinner">
  <span class="loading-spinner__dot"></span>
  <span class="loading-spinner__dot"></span>
  <span class="loading-spinner__dot"></span>
</div>
